export default __webpack_public_path__ + "static/media/microsoft-teams.e00d7d53.svg";